import React from "react";
import { Link } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";

class EventSchedulesOne extends React.Component {
  openTabSection = (evt, tabNmae) => {
    let i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabs_item");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }

    tablinks = document.getElementsByTagName("li");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace("current", "");
    }

    document.getElementById(tabNmae).style.display = "block";
    evt.currentTarget.className += "current";
  };
  render() {
    return (
      <section className="schedule-area bg-image ptb-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="tab">
                <ul className="tabs active">
                  <li
                    onClick={(e) => this.openTabSection(e, "tab1")}
                    className="current"
                  >
                    <Link to="#">
                      Primer día
                      <span>14 de octubre de 2022</span>
                    </Link>
                  </li>

                  <li onClick={(e) => this.openTabSection(e, "tab2")}>
                    <Link to="#">
                      Segundo día
                      <span>15 de octubre de 2022</span>
                    </Link>
                  </li>
                </ul>

                <div className="tab_content">
                  <div id="tab1" className="tabs_item">
                    <Accordion defaultActiveKey="0" flush>
                      <Accordion.Item eventKey="0">
                        <h3 className="not-accordion">
                          Recepción de congresistas
                        </h3>
                        <ul>
                          <li>
                            <i className="icofont-wall-clock"></i> 09:30am -
                            10:00am
                          </li>
                        </ul>
                      </Accordion.Item>

                      <Accordion.Item eventKey="1">
                        <h3 className="not-accordion">Acto inaugural</h3>
                        <ul>
                          <li>
                            <i className="icofont-wall-clock"></i> 10:00am -
                            10:30am
                          </li>
                        </ul>
                      </Accordion.Item>

                      <Accordion.Item eventKey="2">
                        <Accordion.Header as="div" bsPrefix="schedule-info">
                          <h3>Sorprendizaje</h3>
                          <div className="author author-multi">
                            <img
                              src={require("../../assets/images/ponentes/ramon-barrera-th.jpg")}
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Ramón Barrera"
                              alt="Author"
                            />
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <strong>
                            Ponencia sobre educación y la pasión por educar.
                          </strong>
                          <br />
                          Licenciado en Derecho, Experto en Coaching,
                          Especialista Universitario en Marketing, Postgrado en
                          Diseño y Dirección de Proyectos.
                          <br />
                          <Link to="/ponentes#ramon-barrera">
                            Más información
                          </Link>
                        </Accordion.Body>
                        <ul>
                          <li>
                            <i className="icofont-wall-clock"></i> 10:30am -
                            11:15am
                          </li>
                          <li>
                            <i className="icofont-user-suited"></i>Ramón Barrera
                          </li>
                        </ul>
                      </Accordion.Item>

                      <Accordion.Item eventKey="4">
                        <Accordion.Header as="div" bsPrefix="schedule-info">
                          <h3>
                            Mesa redonda: ¿cómo se educa la autonomía y la
                            libertad?
                          </h3>
                        </Accordion.Header>
                        <Accordion.Body>
                          <Link to="/ponentes#autonomia-conocimiento">
                            Más información
                          </Link>
                        </Accordion.Body>
                        <ul>
                          <li>
                            <i className="icofont-wall-clock"></i> 11:15am -
                            12:00pm
                          </li>
                        </ul>
                      </Accordion.Item>

                      <Accordion.Item eventKey="5">
                        <h3 className="not-accordion">
                          CAFÉ. Visita a Exposición
                        </h3>
                        <ul>
                          <li>
                            <i className="icofont-wall-clock"></i> 12:00pm -
                            12:45pm
                          </li>
                        </ul>
                      </Accordion.Item>

                      <Accordion.Item eventKey="6">
                        <Accordion.Header as="div" bsPrefix="schedule-info">
                          <h3>Neuroconexiones</h3>
                          <div className="author author-multi">
                            <img
                              src={require("../../assets/images/ponentes/anna-fores.jpg")}
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Anna Forés"
                              alt="Author"
                            />
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <strong>Ponencia sobre neuroeducación.</strong>
                          <br />
                          Directora adjunta de la cátedra de Neurociencia UB
                          EDU1ST de la Universidad de Barcelona
                          <br />
                          <Link to="/ponentes#anna-fores">Más información</Link>
                        </Accordion.Body>
                        <ul>
                          <li>
                            <i className="icofont-wall-clock"></i> 12:45pm -
                            13:30pm
                          </li>
                          <li>
                            <i className="icofont-user-suited"></i>Anna Forés
                          </li>
                        </ul>
                      </Accordion.Item>

                      <Accordion.Item eventKey="7">
                        <Accordion.Header>
                          <h3>Mesa redonda: La euforia de la innovación.</h3>
                        </Accordion.Header>
                        <Accordion.Body>
                          <Link to="/ponentes#euforia-innovacion">
                            Más información
                          </Link>
                        </Accordion.Body>
                        <ul>
                          <li>
                            <i className="icofont-wall-clock"></i> 13:30pm -
                            14:15pm
                          </li>
                        </ul>
                      </Accordion.Item>

                      <Accordion.Item eventKey="8">
                        <h3 className="not-accordion">
                          ALMUERZO. Visita a exposición
                        </h3>
                        <ul>
                          <li>
                            <i className="icofont-wall-clock"></i> 14:15pm -
                            15:15pm{" "}
                          </li>
                        </ul>
                      </Accordion.Item>

                      <Accordion.Item eventKey="9">
                        <Accordion.Header as="div" bsPrefix="schedule-info">
                          <h3>
                            Pedagogía cinco estrellas. Un modelo orgánico al
                            servicio de algo nuevo.
                          </h3>
                          <div className="author author-multi">
                            <img
                              src={require("../../assets/images/ponentes/p-victor-th.jpg")}
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Víctor Pérez"
                              alt="Author"
                            />
                          </div>
                        </Accordion.Header>

                        <Accordion.Body>
                          <strong>Ponencia sobre Educación Orgánica.</strong>
                          <br />
                          Director de la Fundación Pentecostés, sacerdote del
                          Instituto de los Padres de Schoenstatt.
                          <br />
                          <Link to="/ponentes#p-victor">Más información</Link>
                        </Accordion.Body>
                        <ul>
                          <li>
                            <i className="icofont-wall-clock"></i> 15:30pm -
                            16:15pm
                          </li>
                          <li>
                            <i className="icofont-user-suited"></i>P. Víctor
                            Pérez
                          </li>
                        </ul>
                      </Accordion.Item>

                      <Accordion.Item eventKey="10">
                        <h3 className="not-accordion">Visita “Aulas Vivas”</h3>
                        <ul>
                          <li>
                            <i className="icofont-wall-clock"></i> 16:15pm -
                            17:15pm
                          </li>
                        </ul>
                      </Accordion.Item>

                      <Accordion.Item eventKey="11">
                        <Accordion.Header as="div" bsPrefix="schedule-info">
                          <h3>
                            Mesa redonda: Universidad: conocimiento, ¿o algo
                            más?
                          </h3>
                        </Accordion.Header>
                        <Accordion.Body>
                          <Link to="/ponentes#universidad-conocimiento">
                            Más información
                          </Link>
                        </Accordion.Body>
                        <ul>
                          <li>
                            <i className="icofont-wall-clock"></i> 17:15pm -
                            18:00pm
                          </li>
                        </ul>
                      </Accordion.Item>
                    </Accordion>
                  </div>

                  <div id="tab2" className="tabs_item">
                    <Accordion defaultActiveKey="0" flush>
                      <Accordion.Item eventKey="0">
                        <Accordion.Header as="div" bsPrefix="schedule-info">
                          <h3>
                            Talleres: Educar a la persona (Persona y vida
                            interior)
                          </h3>
                        </Accordion.Header>
                        <Accordion.Body>
                          T1. <strong>+Educa. </strong>Colegio Monte Tabor
                          Schoenstatt. <br />
                          T2. <strong>Pedagodía 5 Estrellas. </strong>Colegio
                          Santa María de Lisboa.
                          <br />
                          T3.{" "}
                          <strong>
                            Arte y emociones en el Programa Educación
                            Responsable.
                          </strong>{" "}
                          Fundación Botín.
                          <br />
                          T4. <strong>Claves del acompañamiento. </strong>{" "}
                          Universidad Francisco de Vitoria.
                          <br />
                          Taller Extra*.{" "}
                          <strong>Conectar a través de la voz.</strong> Escuela
                          de música EMEX Monte Tabor.
                          <br />
                          <br />
                          <Link to="/talleres">Más información</Link>
                        </Accordion.Body>
                        <ul>
                          <li>
                            <i className="icofont-wall-clock"></i> 09:30am -
                            10:15am
                          </li>
                        </ul>
                      </Accordion.Item>

                      <Accordion.Item eventKey="1">
                        <Accordion.Header as="div" bsPrefix="schedule-info">
                          <h3>
                            Talleres: Educar es vincular (Persona y comunidad)
                          </h3>
                        </Accordion.Header>

                        <Accordion.Body>
                          T5. <strong>Atención a la Diversidad. </strong>Colegio
                          Monte Tabor Schoenstatt. <br />
                          T6.{" "}
                          <strong>El clima como herramienta educativa. </strong>
                          Colegio Nuestra Señora de Schoenstatt.
                          <br />
                          T7.{" "}
                          <strong>
                            MIAA: Modelo de Intervención de Apoyo al
                            Aprendizaje. Atendiendo la diversidad de nuestros
                            alumnos.{" "}
                          </strong>
                          Colegio Monte Tabor y Nazaret (Santiago de Chile).
                          <br />
                          T8.{" "}
                          <strong>
                            {" "}
                            Conectando a través del Arte. Visual Thinking
                            Strategies.
                          </strong>
                          Bettina Ingham (Explorarte)
                          <br />
                          Taller Extra*.{" "}
                          <strong>Conectar a través de la voz.</strong> Escuela
                          de música EMEX Monte Tabor.
                          <br />
                          <br />
                          <Link to="/talleres">Más información</Link>
                        </Accordion.Body>
                        <ul>
                          <li>
                            <i className="icofont-wall-clock"></i> 10:20am -
                            11:15am
                          </li>
                        </ul>
                      </Accordion.Item>

                      <Accordion.Item eventKey="2">
                        <h3 className="not-accordion">
                          CAFÉ. Visita a exposición
                        </h3>
                        <ul>
                          <li>
                            <i className="icofont-wall-clock"></i> 11:20am -
                            11:50am
                          </li>
                        </ul>
                      </Accordion.Item>

                      <Accordion.Item eventKey="3">
                        <Accordion.Header as="div" bsPrefix="schedule-info">
                          <h3>
                            Talleres: En y para el Mundo (Persona y mundo)
                          </h3>
                        </Accordion.Header>
                        <Accordion.Body>
                          T9. <strong>Los Futuros de la Educación. </strong>SM.
                          Proyecto de educación social.
                          <br />
                          T10.{" "}
                          <strong>
                            Conectando colegio y universidad, colegio y
                            sociedad.{" "}
                          </strong>
                          Colegio Sagrada Familia Chile.
                          <br />
                          T11. <strong>Programa 4º ESO + Empresa. </strong>
                          Colegio Santa María la Blanca.
                          <br />
                          T12.{" "}
                          <strong>
                            Modelo de integración de educación especial.{" "}
                          </strong>
                          Colegio Cambrils.
                          <br />
                          Taller Extra*.{" "}
                          <strong>Conectar a través de la voz.</strong> Escuela
                          de música EMEX Monte Tabor.
                          <br />
                          <br />
                        </Accordion.Body>
                        <ul>
                          <li>
                            <i className="icofont-wall-clock"></i> 11:55am -
                            12:40pm
                          </li>
                        </ul>
                      </Accordion.Item>

                      <Accordion.Item eventKey="4">
                        <Accordion.Header as="div" bsPrefix="schedule-info">
                          <h3>Los nuevos profesores. Creando conexiones</h3>
                          <div className="author author-multi">
                            <img
                              src={require("../../assets/images/ponentes/carmen-pellicer.png")}
                              data-toggle="tooltip"
                              data-placement="top"
                              title="Carmen Pellicer"
                              alt="Author"
                            />
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <strong>
                            Ponenecia sobre el papel clave del profesor en el
                            presente y futuro educativo.
                          </strong>
                          <br />
                          Teóloga, pedagoga y escritora, es la presidenta de la
                          Fundación Trilema y de la AECOPE. Directora de
                          'Cuadernos de Pedagogía' y del Máster Learning Leaders
                          de la Universidad Cardenal Spínola CEU de Sevilla.
                          <br />
                          <Link to="/ponentes#carmen-pellicer">
                            Más información
                          </Link>
                        </Accordion.Body>
                        <ul>
                          <li>
                            <i className="icofont-wall-clock"></i> 12:45pm -
                            13:30pm
                          </li>
                          <li>
                            <i className="icofont-user-suited"></i>Carmen
                            Pellicer
                          </li>
                        </ul>
                      </Accordion.Item>

                      <Accordion.Item eventKey="5">
                        <h3 className="not-accordion">
                          Acto de clausura y entrega de premios “Vínculo”
                        </h3>
                        <ul>
                          <li>
                            <i className="icofont-wall-clock"></i> 13:30pm -
                            14:00pm
                          </li>
                        </ul>
                      </Accordion.Item>

                      <Accordion.Item eventKey="6">
                        <h3 className="not-accordion">
                          Entrega de certiﬁcados y despedida
                        </h3>
                        <ul>
                          <li>
                            <i className="icofont-wall-clock"></i> 14:00pm
                          </li>
                        </ul>
                      </Accordion.Item>
                    </Accordion>
                  </div>
                </div>
              </div>

              <div>
                <br />
                *En caso de elegir este taller, hágalo solamente en uno de los
                bloques, ya que se impartirá el mismo las tres veces.
              </div>
            </div>

            <div className="col-lg-12">
              {/* <div className="btn-box">
                                <Link to="#" className="btn btn-primary">Descargar horario (PDF)</Link>
                            </div> */}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default EventSchedulesOne;
